import { Component, OnInit, ChangeDetectorRef, OnDestroy, AfterViewChecked } from '@angular/core';
import { PartGroup } from '../partgroup/partgroup.model';
import { OPCConstant } from '../opc.const';
import { ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-searchresult',
    templateUrl: './searchresult.component.html',
    styleUrls: ['./searchresult.component.css']
})
export class SearchResultComponent implements OnInit, OnDestroy, AfterViewChecked {
    searchResults: any;
    pagedItems: any = {};
    isSearchedByPartNumber = false;
    searchText: string;
    appSettings: any;
    errorMessage: string;
    partSearchErrMessage: string;
    
    private paramObservable: any;
    constructor(private _route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    }
    setPageData(data: any) {
        this.pagedItems.data = this.searchResults.slice(data.startIndex, data.endIndex);
        this.pagedItems.routeName = 'partgroup';
    }
    ngOnInit(): void {
        this.paramObservable = this._route.params.subscribe(params => {
          this.searchResults = this._route.snapshot.data['search'];
          this.searchText = params['text'];
          this.appSettings = localStorage.getItem("settings");
          const value = JSON.parse(this.appSettings);
          this.errorMessage = value.opcSettings.partSearchErrMessage;
          this.partSearchErrMessage = this.errorMessage.replace('{{searchText}}', this.searchText);

            if (this.searchResults.partDTO) {
                this.isSearchedByPartNumber = true;
            } else {
                this.isSearchedByPartNumber = false;
            }
        });
    }
    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }
    ngOnDestroy() {
        if (this.paramObservable != null) {
            this.paramObservable.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/searchresult/searchresult.component.ts